<template>
    <div class="relative">
        <div v-show="active">
            <slot />
        </div>
        <div class="absolute invisible top-0 left-0 h-full" ref="content">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop, Ref } from 'vue-property-decorator';

@Component
export default class Tab extends Vue {
    @Ref('content') content: HTMLElement;
    @Inject({
        default: () => null
    }) readonly registerTab!: Function;

    @Prop({ required: true }) title: string;

    active = true;

    mounted() {
        this.registerTab(this, this.content.clientHeight);
    }
}
</script>
